import { atom } from 'jotai';
import type { Incident } from '../types';

export const incidentsAtom = atom<Incident[]>([]);
export const isLoadingIncidentsAtom = atom<boolean>(false);
export const selectedIncidentAtom = atom<Incident | null>(null);

// Filtering
export const incidentTypeFilterAtom = atom<string | null>(null);
export const severityFilterAtom = atom<string | null>(null);
export const dateRangeFilterAtom = atom<{ start: Date | null; end: Date | null }>({ start: null, end: null });

// Sorting
export const sortByAtom = atom<'date' | 'severity' | 'type'>('date');
export const sortDirectionAtom = atom<'asc' | 'desc'>('desc');